import { useState, useEffect } from 'react'
import { useField } from 'formik'
import * as Yup from 'yup'

export function useValidField<T extends Yup.Maybe<string>>(
  name: string,
  validationSchema: Yup.StringSchema<T, Yup.AnyObject, string | undefined, Yup.Flags>
): T | undefined {
  const [validFieldValue, setValidFieldValue] = useState<T | undefined>(undefined)
  const [field] = useField(name)

  useEffect(() => {
    let isMounted = true

    validationSchema.isValid(field.value).then((isValid) => {
      if (isValid && isMounted) {
        setValidFieldValue(field.value)
      }
    })

    return () => {
      isMounted = false
    }
  }, [validationSchema, field.value, name])

  return validFieldValue
}
